module.exports = __webpack_public_path__ + "img/banner-principal-decorativo-1.6a1e3a28.svg";